import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useImageGeneration () {
    const [generatedImage, setGeneratedImage] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const imageGenerationApi = useApi('ImageGeneration');
    const imageGenerationLoad = useRef(true);

    useEffect(() => {
        if (imageGenerationLoad.current) {
            imageGenerationLoad.current = false;
            return;
        }

        setGeneratedImage(imageGenerationApi.data);
        setLoading(imageGenerationApi.loading);
        setError(imageGenerationApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageGenerationApi]);

    const generateImage = async (image, prompt, mask) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("Image", image);
        formData.append("Prompt", prompt);

        if (mask) {
            formData.append("Mask", mask);
        }

        imageGenerationApi.post(formData, {headers: {'Accept': 'multipart/form-data'}, responseBody: 'blob'});
    }

    const getBlob = () => {
        return generatedImage ? URL.createObjectURL(generatedImage) : null;
    }

    return {
        generatedImage,
        error,
        loading,
        generateImage,
        getBlob
    };
}

export default useImageGeneration;